export enum ADigitSize {
  XL = 'XL',
  L = 'L',
  M = 'M',
  S = 'S',
  XS = 'XS',
  /** @deprecated Prefer `ADigitSize.XL`. */
  ExtraLarge = 'ExtraLarge',
  /** @deprecated Prefer `ADigitSize.L`. */
  Large = 'Large',
  /** @deprecated Prefer `ADigitSize.M`. */
  Medium = 'Medium',
  /** @deprecated Prefer `ADigitSize.S`. */
  Small = 'Small',
  /** @deprecated Prefer `ADigitSize.XS`. */
  ExtraSmall = 'ExtraSmall',
}

export interface ADigitProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * The size variant of the digit
   */
  size?: ADigitSize;
  /**
   * The text to render
   */
  text: string;
}
